import css from 'styled-jsx/css';

const styles = css.global`#cdc-avisar-sinistro {
    padding-top: 32px;
}

#cdc-avisar-sinistro .ctn-home-24 {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

#cdc-avisar-sinistro .avisar-sinistro,
#cdc-avisar-sinistro .informacoes-seguro {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

#cdc-avisar-sinistro .avisar-sinistro-titulo {
    color:#444;
    font-family: "SantanderHeadline";
    font-size: 40px;
    font-style: normal;
    font-weight: 400;
    line-height: 60px;
}

#cdc-avisar-sinistro .avisar-sinistro-botoes {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

#cdc-avisar-sinistro .avisar-sinistro-texto-botoes,
#cdc-avisar-sinistro .informacoes-texto-botao {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding-bottom: 16px;
}

#cdc-avisar-sinistro .avisar-sinistro-texto-botoes .avisar-sinistro-texto,
#cdc-avisar-sinistro .informacoes-texto-botao .informacoes-texto {
    color:#444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#cdc-avisar-sinistro .avisar-sinistro-texto-botoes .btn-avisar-sinistro,
#cdc-avisar-sinistro .avisar-sinistro-texto-botoes .btn-canais-atendimento,
#cdc-avisar-sinistro .informacoes-texto-botao .btn-ver-condicoes {
    width: 100%;
    max-width: 272px;
    height: 48px;
    margin: auto;
}

#cdc-avisar-sinistro .informacoes-titulo {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 48px;
}

@media (min-width: 992px) {
    #cdc-avisar-sinistro {
        padding-top: 40px;
        padding-bottom: 32px;
        position: relative;
    }

    #cdc-avisar-sinistro .ctn-home-24 {
        gap: 88px;
    }

    #cdc-avisar-sinistro .avisar-sinistro,
    #cdc-avisar-sinistro .informacoes-seguro {
        gap: 8px;
    }

    #cdc-avisar-sinistro .avisar-sinistro-titulo {
        font-size: 56px;
        line-height: 120%;
    }

    #cdc-avisar-sinistro .avisar-sinistro-texto-botoes,
    #cdc-avisar-sinistro .informacoes-texto-botao {
        padding-bottom: 0;
    }

    #cdc-avisar-sinistro .avisar-sinistro-texto-botoes .avisar-sinistro-texto,
    #cdc-avisar-sinistro .informacoes-texto-botao .informacoes-texto {
        font-size: 24px;
        line-height: 36px;
    }

    #cdc-avisar-sinistro .avisar-sinistro-texto-botoes .btn-avisar-sinistro,
    #cdc-avisar-sinistro .avisar-sinistro-texto-botoes .btn-canais-atendimento,
    #cdc-avisar-sinistro .informacoes-texto-botao .btn-ver-condicoes {
        margin: 0;
    }

    #cdc-avisar-sinistro .informacoes-titulo {
        font-size: 40px;
        line-height: 60px;
    }

    #cdc-avisar-sinistro .avisar-sinistro-botoes {
        flex-direction: row;
    }

    #cdc-avisar-sinistro .img-bolinhas-sinistro {
        position: absolute;
        top: 77px;
        right: 0;
    }
}`;

export default styles;